import React, { useEffect, useRef } from 'react';
import QRCodeStyling from 'qr-code-styling';
import './QRCodeDisplay.css';

/**
 * StylizedQRCodeDisplay Component
 *
 * A QR code display with blue-to-purple gradient and rounded dots.
 * Uses qr-code-styling for native gradient support.
 */
const StylizedQRCodeDisplay = ({ url, size = 300 }) => {
  const qrRef = useRef(null);
  const qrCode = useRef(null);

  useEffect(() => {
    if (!qrCode.current) {
      qrCode.current = new QRCodeStyling({
        type: 'svg',
        width: size,
        height: size,
        data: url || '',
        margin: 0,
        qrOptions: {
          typeNumber: 0,
          mode: 'Byte',
          errorCorrectionLevel: 'M',
        },
        dotsOptions: {
          type: 'rounded',
          gradient: {
            type: 'linear',
            rotation: (45 * Math.PI) / 180,
            colorStops: [
              { offset: 0, color: '#48C0FC' }, // Blue
              { offset: 1, color: '#8A4FFF' }, // Purple
            ],
          },
        },
        backgroundOptions: {
          color: 'transparent',
        },
        cornersSquareOptions: {
          type: 'extra-rounded',
          gradient: {
            type: 'linear',
            rotation: (45 * Math.PI) / 180,
            colorStops: [
              { offset: 0, color: '#48C0FC' },
              { offset: 1, color: '#8A4FFF' },
            ],
          },
        },
        cornersDotOptions: {
          type: 'dot',
          gradient: {
            type: 'linear',
            rotation: (45 * Math.PI) / 180,
            colorStops: [
              { offset: 0, color: '#48C0FC' },
              { offset: 1, color: '#8A4FFF' },
            ],
          },
        },
      });
    }

    if (qrCode.current && url) {
      qrCode.current.update({ data: url });
    }

    if (qrRef.current && qrCode.current) {
      qrRef.current.innerHTML = '';
      qrCode.current.append(qrRef.current);
    }
  }, [url, size]);

  return (
    <div className="qr-code-container">
      {url ? (
        <div ref={qrRef} />
      ) : (
        <div className="qr-loading" style={{ width: `${size}px`, height: `${size}px` }}>
          {/* Empty div - no loading text */}
        </div>
      )}
    </div>
  );
};

export default StylizedQRCodeDisplay;
